<div wlCSMask>
  <div [id]="selector">
    <crnt-icon
      [className]="'text-brand'"
      [size]="'3x'"
      [animation]="'spin'"
      [icon]="'spinner-third'"
    >
    </crnt-icon>
  </div>
</div>
